import { AustrianFlag } from '@pixum/svg-icon/lib/Flags/AustrianFlag';
import { BelgianFlag } from '@pixum/svg-icon/lib/Flags/BelgianFlag';
import { DanishFlag } from '@pixum/svg-icon/lib/Flags/DanishFlag';
import { DutchFlag } from '@pixum/svg-icon/lib/Flags/DutchFlag';
import { EnglishFlag } from '@pixum/svg-icon/lib/Flags/EnglishFlag';
import { FinnishFlag } from '@pixum/svg-icon/lib/Flags/FinnishFlag';
import { FrenchFlag } from '@pixum/svg-icon/lib/Flags/FrenchFlag';
import { GermanFlag } from '@pixum/svg-icon/lib/Flags/GermanFlag';
import { IrishFlag } from '@pixum/svg-icon/lib/Flags/IrishFlag';
import { ItalianFlag } from '@pixum/svg-icon/lib/Flags/ItalianFlag';
import { LuxembourgFlag } from '@pixum/svg-icon/lib/Flags/LuxembourgFlag';
import { PortugueseFlag } from '@pixum/svg-icon/lib/Flags/PortugueseFlag';
import { SpanishFlag } from '@pixum/svg-icon/lib/Flags/SpanishFlag';
import { SwedishFlag } from '@pixum/svg-icon/lib/Flags/SwedishFlag';
import { SwissFlag } from '@pixum/svg-icon/lib/Flags/SwissFlag';

import type { IconProps } from '@pixum/svg-icon/lib/types';
import type { FC } from 'react';
import { CDN_HOST, PNG_MEDIA_RESOURCES } from '../../constants';

export const SVG_FLAG_RESOURCES: Record<string | number, FC<IconProps>> = {
  0: GermanFlag,
  1: EnglishFlag,
  14: DutchFlag,
  16: AustrianFlag,
  18: EnglishFlag,
  24: FrenchFlag,
  37: BelgianFlag,
  38: BelgianFlag,
  47: ItalianFlag,
  48: SpanishFlag,
  63: PortugueseFlag,
  51: DanishFlag,
  52: SwedishFlag,
  61: FinnishFlag,
  62: IrishFlag,
  17: SwissFlag,
  135: SwissFlag,
  123: SwissFlag,
  138: LuxembourgFlag
};

export interface IconResource {
  src: string;
  width?: number;
  height?: number;
}

export const SVG_LOGO_RESOURCES: Record<string, IconResource> = {
  delivery_ontime: { src: 'images/svg/partner-logos/ontime-dark.svg', width: 145, height: 38 },
  delivery_correos: { src: 'images/svg/partner-logos/correos-dark.svg', width: 36, height: 33 },
  delivery_die_post: { src: 'images/svg/partner-logos/delivery_die_post-dark.svg', width: 32, height: 32 },
  delivery_bpost: { src: 'images/svg/partner-logos/bpost-color.svg', width: 69, height: 40 },
  delivery_laposte: { src: 'images/svg/partner-logos/la-poste-dark.svg', width: 169, height: 25 },
  delivery_post_at: { src: 'images/svg/partner-logos/post-at-dark.svg', width: 60, height: 30 },
  secure_trustedshops: { src: 'images/svg/partner-logos/trusted-shops-dark.svg', width: 74, height: 32 },
  secure_ssl: { src: 'images/svg/partner-logos/SSL-dark.svg', width: 51, height: 29 },
  secure_becom: { src: 'images/svg/partner-logos/secure_becom-color.svg', width: 76, height: 27 },
  payment_paypal: { src: 'images/svg/partner-logos/paypal-dark.svg', width: 108, height: 23 },
  delivery_dhl: { src: 'images/svg/partner-logos/dhl-dark.svg', width: 90, height: 27 },
  delivery_poste_italiane: { src: 'images/svg/partner-logos/poste-italiane-dark.svg', width: 160, height: 21 },
  delivery_deutschepost: { src: 'images/svg/partner-logos/deutsche-post-dark.svg', width: 153, height: 27 },
  delivery_ups: { src: 'images/svg/partner-logos/ups-dark.svg', width: 35, height: 42 },
  delivery_royalmail: { src: 'images/svg/partner-logos/royal-mail-dark.svg', width: 67, height: 45 },
  delivery_postnord: { src: 'images/svg/partner-logos/postnord-dark.svg', width: 130, height: 26 },
  delivery_brt: { src: 'images/svg/partner-logos/brt-dark.svg', width: 60, height: 29 },
  delivery_amazonshipping: { src: 'images/svg/partner-logos/amazon-shipping-dark.svg', width: 130, height: 29 },
  delivery_laposte_ch: { src: 'images/svg/partner-logos/la-posta-color.svg', width: 32, height: 32 },
  delivery_laposta_ch: { src: 'images/svg/partner-logos/la-posta-color.svg', width: 32, height: 32 },
  payment_ideal: { src: 'images/svg/partner-logos/ideal-color.svg', width: 77, height: 29 },
  payment_ae: { src: 'images/svg/partner-logos/amex-dark.svg', width: 81, height: 29 },
  payment_postepay: { src: 'images/svg/partner-logos/postepay-dark.svg', width: 116, height: 26 },
  payment_mastercard: { src: 'images/svg/partner-logos/mastercard-dark.svg', width: 53, height: 31 },
  payment_dankort: { src: 'images/svg/partner-logos/dankort-dark.svg', width: 41, height: 25 },
  payment_maestro: { src: 'images/svg/partner-logos/maestro-dark.svg', width: 148, height: 28 },
  payment_visa: { src: 'images/svg/partner-logos/visa-dark.svg', width: 60, height: 20 },
  payment_invoice: { src: 'images/svg/partner-logos/payment_invoice_DE_dark.svg', width: 105, height: 26 },
  payment_rechnung: { src: 'images/svg/partner-logos/payment_rechnung-dark.svg', width: 105, height: 26 },
  payment_invoice_be_nl: { src: 'images/svg/partner-logos/payment_invoice_NL_dark.svg', width: 77, height: 24 },
  payment_factur: { src: 'images/svg/partner-logos/payment_invoie_BEFR-dark.svg', width: 85, height: 26 },
  payment_sepa_lastschrift: {
    src: 'images/svg/partner-logos/payment_sepa-lastschrift_DE_dark.svg',
    width: 82,
    height: 26
  },
  secure_emarket: { src: 'images/svg/partner-logos/secure_emarket-dark.svg', width: 38, height: 29 },
  secure_thuiswinkel: { src: 'images/svg/partner-logos/secure_thuiswinkel-color.svg', width: 114, height: 35 },
  secure_confianza: { src: 'images/svg/partner-logos/sello_confianza-online-dark.svg', width: 36, height: 36 },
  social_facebook: { src: 'images/svg/partner-logos/facebook-dark.svg', width: 32, height: 32 },
  social_instagram: { src: 'images/svg/partner-logos/instagram-dark.svg', width: 32, height: 32 },
  social_pinterest: { src: 'images/svg/partner-logos/pinterest-dark.svg', width: 32, height: 32 },
  social_youtube: { src: 'images/svg/partner-logos/youtube-dark.svg', width: 129, height: 28 },
  pixum_logo_dark: { src: 'images/logo/LogoDark.svg', width: 174, height: 45 },
  'delivery_colis-prive': { src: 'images/svg/partner-logos/delivery_colis-prive-color.svg', width: 32, height: 41 },
  'laptop-dark': { src: 'images/footer/Frame-dark.svg', width: 60, height: 30 },
  'phone-dark': { src: 'images/footer/iPhone-dark.svg', width: 17, height: 30 },
  'check-dark': { src: 'images/footer/check-dark.svg', width: 20, height: 24 }
};

export interface MediaRessource {
  svgResource: FC<IconProps> | undefined;
  iconResource: IconResource | undefined;
}

function getSvgLogoMedia(resource: IconResource): IconResource {
  return { ...resource, src: `${CDN_HOST}/${resource.src}` };
}

function getPngMedia(id: string): IconResource | undefined {
  const src = PNG_MEDIA_RESOURCES[id] || PNG_MEDIA_RESOURCES[id.substring(0, id.length - 3)];

  if (!src) return undefined;

  return { src: `${CDN_HOST}/${src}` };
}

export function getMediaRessource(id: string, color?: string): MediaRessource {
  const coloredId = color ? `${id}_${color}` : id;
  const svgResource = SVG_FLAG_RESOURCES[id];
  const svgLogoResource =
    SVG_LOGO_RESOURCES[coloredId] ||
    SVG_LOGO_RESOURCES[coloredId.substring(0, coloredId.length - 3)] ||
    SVG_LOGO_RESOURCES[id] ||
    SVG_LOGO_RESOURCES[id.substring(0, id.length - 3)];

  const iconResource = svgLogoResource ? getSvgLogoMedia(svgLogoResource) : getPngMedia(id);

  return {
    svgResource,
    iconResource
  };
}
